//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {apiUrl, apiParams} from '@/const/const'
import MyFooter from '@/components/subComponents/MyFooter'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
    name: 'Voyage',
    components: {
        MyFooter,
        MyBtnReturn,
    },
    data() {
        return {
            place_loading: null,
            place_loadingOps: [
                // {
                //   key: 'gd',
                //   value: '广东'
                // },
                // {
                //   key: 'gx',
                //   value: '广西'
                // }
            ],
            place_delivery: null,
            place_deliveryOps: [
                // {
                //   key: 'gd',
                //   value: '广东'
                // },
                // {
                //   key: 'gx',
                //   value: '广西'
                // }
            ],
            title: [],
            canCall: true, // true代表能继续发送请求，控制search方法的
            startAreaUrl: '', // 查询起运地API，voyageSearch或voyageSearchYeWu
            endAreaUrl: '', // 查询目的地API，changePlace目的地或changePort目的港
            routeName: '',
        }
    },
    created() {
        document.title = '船期查询';
        // this.test()
        // 判断是哪个路由路径，然后获取相应数据
        this.routeName = this.$route.name;
        if (this.routeName === 'VoyageKehu') {
            // 如果是客户应用的
            this.title = ['起始地', '目的地'];
            this.startAreaUrl = apiUrl.voyageSearch;
            this.endAreaUrl = apiUrl.changePlace;
            this.tableDataUrl = apiUrl.voyageTemplate
        } else {
            // 如果是业务应用的
            this.title = ['起始港', '目的港'];
            this.startAreaUrl = apiUrl.voyageSearchYeWu;
            this.endAreaUrl = apiUrl.changePort;
            this.tableDataUrl = apiUrl.voyageTemplateYw
        }

        this.searchArea()
    },
    methods: {
        searchArea() {
            // 获取起始与目的等地点:如果没获取到，要提示用户重新打开页面吗？
            // 这里获取的目的地应该是总数量，可随用户选
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
            };
            this.requestApi({
                url: this.startAreaUrl,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data;
                // todo:囧，结果后台返回了数组里一个null，[null]，selector组件直接崩溃
                if (this.routeName === 'VoyageKehu') {
                    this.place_loadingOps = dataObj.startPlaces || []; // 防止后台返回null
                    this.place_deliveryOps = dataObj.endPlaces || [] // 防止后台返回null
                } else {
                    this.place_loadingOps = dataObj.startPorts || []; // 防止后台返回null
                    this.place_deliveryOps = dataObj.endPorts || [] // 防止后台返回null
                }

            }, (error) => {
                if (error) {
                    console.error(error);
                }
            })
        },
        startChange(value) {
            if (!value) return;
            // 去获取目的地的数据：这是根据起运地获取的，数量应该没startAreaUrl接口的多吧？
            // 加一个loading吧，顺便可以不让用户又去选择另一个起运地
            this.$vux.loading.show({
                text: 'Loading'
            });
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                start: this.place_loading || '',
            };
            this.requestApi({
                url: this.endAreaUrl,
                data: data
            }, (resultData) => {
                this.$vux.loading.hide();
                let dataObj = resultData.data;
                // 囧，结果后台返回了数组里一个null，[null]，selector组件直接崩溃
                if (this.routeName === 'VoyageKehu') {
                    this.place_deliveryOps = dataObj.findEndPlace || [] // 防止后台返回null
                } else {
                    this.place_deliveryOps = dataObj.findEndPort || [] // 防止后台返回null
                }
                this.place_delivery = null; // 目的地被选中项变为null，不然查询时会记忆回来选择的
            }, (error) => {
                this.$vux.loading.hide();
                if (error) {
                    console.error(error);
                }
            })
        },
        search() {
            this.$router.push({
                name: 'VoyageResult',
                query: {
                    place_loading: this.place_loading || '',
                    place_delivery: this.place_delivery || '',
                    routeName: this.routeName, // 传递路由name给结果页面，可以判断是客户还是业务应用
                }
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/voyage/Voyage.vue